// extracted by css-extract-rspack-plugin
export default {"IconButton_0":"OverflowMenu-module__IconButton_0__IensR"};